import { useEffect } from 'react';

import { ITradingAccount } from '@webtrader/core/api/user';

import { checkIsNative } from '../validators/device';

const CHANNEL_NAME = 'trading-account-channel';

interface ITradingAccountMessageData extends Pick<ITradingAccount, 'metatraderId' | 'serverId'> {}

export const broadcastTradingAccountChangeMessage = ({ metatraderId, serverId }: ITradingAccountMessageData) => {
  if (checkIsNative()) {
    return;
  }
  const channel = new BroadcastChannel(CHANNEL_NAME);
  channel.postMessage({ metatraderId, serverId });
  channel.close();
};

export const useSyncTradingAccount = (currentAccount: ITradingAccount | undefined) => {
  useEffect(() => {
    const channel = new BroadcastChannel(CHANNEL_NAME);
    channel.onmessage = (event: MessageEvent<ITradingAccountMessageData>) => {
      const { metatraderId, serverId } = event.data ?? {};

      const shouldRefreshTradingAccount =
        !!metatraderId &&
        !!currentAccount?.metatraderId &&
        !!serverId &&
        !!currentAccount?.serverId &&
        (metatraderId !== currentAccount.metatraderId || serverId !== currentAccount.serverId);

      if (shouldRefreshTradingAccount) {
        window.location.reload();
      }
    };
    return () => channel.close();
  }, [currentAccount]);
};
